<fieldset [formGroup]="group" class="in-one-column">
  <legend>{{ TITLE + "TITLE" | translate }}:</legend>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-input
        formControlName="name"
        [label]="TITLE + 'NAME' | translate"
      >
      </app-easy-input>
    </mat-form-field>

    <div class="d-flex align-items-end gap-5">
      <mat-form-field>
        <app-easy-input
          formControlName="ean"
          [label]="TITLE + 'EAN' | translate"
        >
        </app-easy-input>
      </mat-form-field>

      <button
        *ngIf="devMode"
        type="button"
        mat-stroked-button
        color="primary"
        class="mt-2"
        [style.height]="'min-content'"
        (click)="generateRandomLengthNumber(13, 'ean')"
      >
        Generate EAN
      </button>
    </div>

    <mat-form-field>
      <app-easy-input
        formControlName="grossWeightInKilograms"
        [label]="TITLE + 'GROSS_WEIGHT_IN_KILOGRAMS' | translate"
        type="number"
        min="0"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <!-- customerSegment subform -->

  <app-product-customer-segment-subform
    groupName="customerSegment"
  ></app-product-customer-segment-subform>

  <app-easy-localized-value-subform
    class="w-100"
    [formGroupAbstract]="group.get('shortDescription')!"
    [title]="'PACKAGING.NEW.TITLE.shortDescription'"
    [textareaAutosizeMinRows]="3"
  ></app-easy-localized-value-subform>

  <app-easy-localized-value-subform
    class="w-100"
    [formGroupAbstract]="group.get('detailedDescription')!"
    [title]="'PACKAGING.NEW.TITLE.detailedDescription'"
    [textareaAutosizeMinRows]="3"
  ></app-easy-localized-value-subform>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="marketingLabels"
        [label]="TITLE + 'MARKETING_LABELS' | translate"
        [translatePrefixForSelected]="'PRODUCTS.MARKETING_LABELS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [limit]="2"
        [multiple]="true"
        [options]="
          marketingLabels | toSelectOption: 'PRODUCTS.MARKETING_LABELS.'
        "
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="experienceCategories"
        [label]="TITLE + 'EXPERIENCE_CATEGORIES' | translate"
        [translatePrefixForSelected]="'PRODUCTS.EXPERIENCE_CATEGORIES.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [limit]="2"
        [multiple]="true"
        [options]="
          experienceCategories
            | toSelectOption: 'PRODUCTS.EXPERIENCE_CATEGORIES.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        formControlName="foodPairings"
        [label]="TITLE + 'FOOD_PAIRINGS' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FOOD_PAIRINGS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [limit]="3"
        [multiple]="true"
        [options]="foodPairings | toSelectOption: 'PRODUCTS.FOOD_PAIRINGS.'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>
</fieldset>
<div class="message-box warning mt-4 mb-4">
  <mat-icon class="icon">info</mat-icon>
  <p class="text">{{ "PRODUCTS.PRODUCT_VARIANT.INFO" | translate }}</p>
</div>
